enum InteractionMode {
  SCROLL_TO_PAN = 'scrollToPan',
  SCROLL_TO_ZOOM = 'scrollToZoom',
}

export default InteractionMode;
